import * as React from 'react';
import { routerShape, locationShape } from 'react-router';

import PropTypes from 'prop-types';
import CurrentUser from 'auth/CurrentUser';

import ToastActions from 'actions/ToastActions';
// @ts-ignore
import View from 'components/View';
import { PromptNames } from 'constants/PromptConstants';
// @ts-ignore
import PromptStore from 'stores/PromptStore';
// @ts-ignore
import PromptActions from 'actions/PromptActions';
import LinkDevicePage from 'user/components/LinkDevicePage';
// @ts-ignore
import UserActions from 'user/UserActions';

class SetupEmail extends React.Component<{}> {
  static contextTypes = {
    router: routerShape,
    location: locationShape,
  };

  componentDidMount() {
    if (!PromptStore.hasDismissed(PromptNames.NUX_SETUP_EMAIL_DEVICE)) {
      PromptActions.recordDismissal(PromptNames.NUX_SETUP_EMAIL_DEVICE);
    }
  }

  handleSave = (_?: string, deviceUid?: string) => {
    UserActions.update({ email: deviceUid }).then(
      () => this.context.router.push(this.context.location?.state?.location ?? '/'),
      (error: Error) => {
        console.debug(error);
        console.error('SetupEmail: could not save user email');
        ToastActions.showErrorToast('An error occured, please try again.');
      }
    );
  };

  onDone = () => {
    this.context.router.push('/');
  };

  render() {
    const skipEnabled =
      CurrentUser.getUser().getRole() == 'student' || CurrentUser.getUser().getRole() == 'parent';

    if (skipEnabled) {
      return (
        <View>
          <LinkDevicePage
            onDone={this.handleSave}
            deviceType="email"
            onSkip={this.onDone}
            title="What is your email address?"
            subtext={
              'We’ll send a code to your device. This will be your primary email address for Remind.'
            }
          />
        </View>
      );
    } else {
      return (
        <View>
          <LinkDevicePage
            onDone={this.handleSave}
            deviceType="email"
            title="What is your email address?"
            subtext={
              'We’ll send a code to your device. This will be your primary email address for Remind.'
            }
          />
        </View>
      );
    }
  }
}

export default SetupEmail;
